<template>
  <div>
    <v-sheet>
      <v-toolbar flat>
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          dark
          color="error"
          @click="onSubmit"
          :loading="loading"
        >
          <v-icon :left="$vuetify.breakpoint.smAndUp">mdi-delete</v-icon>
          <div class="hidden-xs-only">{{ submitButtonText }}</div>
        </v-btn>
      </v-toolbar>
      <v-container fluid>
        <v-row no-gutters>
          <v-col cols="12">
            <v-text-field
              :value="edited.orden"
              placeholder="Ingrese un orden"
              label="Orden"
              prepend-icon="mdi-label"
              color="error"
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field
              :value="edited.nombre"
              label="Nombre"
              prepend-icon="mdi-map-marker"
              color="error"
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field
              :value="edited.descripcion"
              placeholder="Ingrese un descripcion"
              label="Descripcion"
              color="error"
              prepend-icon="mdi-counter"
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field
              :value="edited.color"
              label="Color"
              prepend-icon="mdi-palette"
              color="error"
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field
              :value="edited.icono"
              label="Icono"
              prepend-icon="mdi-text"
              color="error"
              readonly
            ></v-text-field>
          </v-col>
        </v-row>
      </v-container>
    </v-sheet>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  components: {
    //
  },
  data () {
    return {
      redirect: 'estados-list',
      title: '¿Está seguro de borrar este registro?',
      submitButtonText: 'Borrar',
      cancelButtonText: 'Cancelar',
    }
  },
  created () {
    this.onDefaults()
    if (this.$route.params.id)
      this.onFind(this.$route.params.id)
  },
  computed: {
    ...mapGetters({
      edited: 'Estados/edited',
      loading: 'Estados/loading',
    }),
  },
  methods: {
    ...mapActions({
      onDelete: 'Estados/onDelete',
      onFind: 'Estados/onFind',
      onDefaults: 'Estados/onDefaults',
    }),
    onCancel () {
      this.$router.push({ name: this.redirect })
    },
    onSubmit () {
      this.onDelete().then(response => {
        this.$router.push({ name: this.redirect })
      })
    },
  },
}
</script>
